export enum EAmbiente {
  desktop = 1,
  mobile = 2,
};